const ColorConstants = {
  Default: '#7f8492',
  AvatarColor: "#f63",
  AvatarBackgroundColor: "ECEFF5",
  UnsavedAvatarColor: "#ffd700",
  WhiteAlien: '#ffffff',
  BlueAlien: "#1976d2",
  LightGrayAlien: "#f8f8f8",
  MidLightGrayAlien: "#e6e6e6",
  MidGray: "#b8b8b8",
  GrayAlien: "#353535",
  Green: "SeaGreen",
  LessLightGrayAlien: "#eaeaea",
  CustomFilterBackground: "#f6fdff",
  MuiSliderBackground: "#bfbfbf",
  GrayBoxAlien: "#7f8492",
  AvatarGray: "#bdbdbd",
  TextDefault: "#000000",

  // Status Colors
  StatusColors: {
    Draft: '#ff8c00',
    ReadyForApproval: '#dfdf6b',
    Completed: '#00a498',
    NotStarted: '#B1D4E0',
    Started: '#6495ED',
    DepartmentApproved: '#4B0082',
    AgencyApproved: '#663399',
    RegionApproved: '#9370b7',
    LocalApproved: '#c1add6',
    // Note: Cancelled must be handled in the css for each file as it uses more intricate css
  },

  // Project Colors
  ProjectColors: {
    Default: '#ff3300'
  },

  // Card Background Colors
  CarryOver: '#ffecbf',

  PopupHeaderColors: {
    error: "#cc180e",
    warning: "#fcd303",
    info: "#0e60cc",
    success: "#00cc18"
  },

  SQLColors: {
    sqlText: "#494949"
  }

};

export default ColorConstants;
